/**
 * 引用源品牌色映射（公共）
 * 用于 6.4 AI引用源与权威性分析 图表配色
 * key 格式：匹配词用英文逗号连接，命中任一即使用该颜色（品牌名不含逗号，无歧义）
 */
export const SOURCE_COLORS: Record<string, string> = {
  // ── 资讯/媒体 ──
  'toutiao,头条,今日头条': '#E84A4A',
  'sohu,搜狐,搜狐新闻': '#D9442A',
  'weibo,微博,新浪微博': '#C41A1A',
  'netease,网易,网易新闻': '#A61C2E',
  'zhihu,知乎': '#0084FF',
  'baijiahao,百家号,百度百家': '#1A3A8A',
  'tencent,腾讯,腾讯新闻,腾讯汽车': '#1677FF',
  'jiemian,界面,界面新闻': '#1B3A5C',
  'nanfang,南方财经,南方': '#0D9488',

  // ── 财经证券 ──
  'xinlang,新浪,新浪财经': '#FF8200',
  'zhengquanshibao,证券时报': '#1E40AF',
  'zhengquanstar,证券之星': '#D97706',
  'zhongzhengwang,中证网,中证': '#2563EB',
  'tonghuashun,同花顺': '#DC2626',
  'dongfangcaifu,东方财富,东方财窗,东方': '#CA0B1F',
  'zhongguojijinbao,中国基金报,基金报': '#16A34A',
  'tiantianjijin,天天基金,天天基金网': '#22A06B',
  'yifangda,易方达,易方达基金': '#4F46E5',
  'koumi,叩蜜,叩蜜网': '#0891B2',

  // ── 电商/社区/平台 ──
  'taobao,淘宝': '#FF6A00',
  'xiaohongshu,小红书': '#FE2C55',
  'douyin,抖音': '#FE2C55',
  'bilibili,B站,b站,哔哩哔哩': '#FB7299',
  'wechat,微信,公众号': '#07C160',
  'baidu,百度,百度百科': '#4E6EF2',

  // ── 汽车垂媒 ──
  'autohome,汽车之家': '#0D6EFD',
  'dongchedi,懂车帝': '#FF6600',
}

export function matchSourceColor(name: string): string | undefined {
  if (!name) return undefined
  const key = name.replace(/\s+/g, '').toLowerCase()
  for (const [joined, color] of Object.entries(SOURCE_COLORS)) {
    if (joined.toLowerCase().includes(key)) return color
  }
  return undefined
}
